import React, { useEffect } from "react";
import useTranslation from "../i18n/useTranslation";

const InviteRedirect = () => {
    const { t } = useTranslation();

    useEffect(() => {
        const prevTitle = document.title;
        document.title = t("inviteRedirect.meta.title");

        const searchParams = new URLSearchParams(window.location.search);
        const token = searchParams.get("token");
        const type = searchParams.get("type");
        const assignmentId = searchParams.get("assignmentId");
        const appParams = new URLSearchParams();
        if (type) appParams.set("type", type);
        if (token) appParams.set("token", token);
        if (assignmentId) appParams.set("assignmentId", assignmentId);
        const appLink = `kbolasport://?${appParams.toString()}`;

        const isAndroid = /android/i.test(navigator.userAgent);
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

        const iosStoreUrl = "https://apps.apple.com/app/id6743017131";
        const androidStoreUrl =
            "https://play.google.com/store/apps/details?id=com.alejandromf27.kbolasportsmobile";

        window.location.href = appLink;

        const timeout = setTimeout(() => {
            if (isAndroid) {
                window.location.href = androidStoreUrl;
            } else if (isIOS) {
                window.location.href = iosStoreUrl;
            } else {
                window.location.href = "/";
            }
        }, 1500);

        return () => {
            clearTimeout(timeout);
            document.title = prevTitle;
        };
    }, [t]);

    useEffect(() => {
        const styleId = "invite-redirect-spinner-style";

        if (!document.getElementById(styleId)) {
            const style = document.createElement("style");
            style.id = styleId;
            style.innerHTML = `
                @keyframes inviteRedirectSpin {
                  to { transform: rotate(360deg); }
                }
            `;
            document.head.appendChild(style);
        }
    }, []);

    return (
        <div style={styles.container}>
            <div style={styles.box}>
                <div className="mb-3">
                    <img
                        src="/dist/img/angeonx-sports.png"
                        alt={t("inviteRedirect.brand.logoAlt")}
                        className="logo img-fluid"
                        style={{ height: "80px", marginBottom: "10px" }}
                    />

                    <h2
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            color: "var(--kbs-primary, #00adff)",
                        }}
                    >
                        {t("inviteRedirect.brand.namePrimary")}{" "}
                        <span style={{ color: "#ffffff" }}>
                            {t("inviteRedirect.brand.nameSecondary")}
                        </span>
                    </h2>
                </div>

                <h1 style={styles.heading}>{t("inviteRedirect.content.title")}</h1>

                <p style={styles.paragraph}>
                    {t("inviteRedirect.content.description")}
                </p>

                <div style={styles.loader} />
            </div>
        </div>
    );
};

const styles = {
    container: {
        backgroundColor: "#14151a",
        height: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,
        fontFamily: "'Poppins', sans-serif",
    },
    box: {
        backgroundColor: "#1f1f2e",
        borderRadius: 12,
        padding: "40px 32px",
        maxWidth: 400,
        textAlign: "center",
        color: "var(--kbs-primary, #00adff)",
        boxShadow: "0 0 30px rgba(0, 0, 0, 0.4)",
    },
    heading: {
        fontSize: 24,
        fontFamily: "'Poppins', sans-serif",
        marginBottom: 16,
    },
    paragraph: {
        fontSize: 16,
        color: "#8d929d",
        marginBottom: 24,
        lineHeight: 1.4,
    },
    loader: {
        width: 36,
        height: 36,
        border: "4px solid var(--kbs-primary, #00adff)",
        borderTop: "4px solid transparent",
        borderRadius: "50%",
        animation: "inviteRedirectSpin 1s linear infinite",
        margin: "0 auto",
    },
};

export default InviteRedirect;
